import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import OptimizerTable from './OptimizerTable';
import { Grid, Paper } from '@mui/material';



export default function FinshedLineups({lineups, addedPlayers}) {



    const convertToCsv = () => {
        if (!lineups || lineups.length === 0) {
          console.error('No lineups to export');
          return;
        }
    
        // Check if lineups have consistent structure
        const lineupStructure = lineups[0].Info[0];
        if (!lineupStructure) {
          console.error('Invalid lineup structure');
          return;
        }
    
        const csvString = [
          Object.keys(lineupStructure).join(','), // Assuming all lineups have the same structure
          ...lineups.map((lineup) =>
            lineup.Info.map((row) => Object.values(row).join(',')).join('\n')
          ),
        ].join('\n');
    
        // Create a Blob with the CSV string
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    
        // Create a download link
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'allOptimizedLineups.csv';
        link.click();
    
        // Cleanup
        window.URL.revokeObjectURL(link.href);
      };


    return (
      <>
      <Paper elevation={3} sx={{padding:2, margin:2}}>
        <Stack direction="row" spacing={2} justifyContent='center'>
            {lineups.length > 0 && <Tooltip title="Download ALL Lineups" placement="left" ><IconButton aria-label="download" onClick={convertToCsv} component='label' sx={{color:"blue"}}><CloudDownloadIcon/></IconButton></Tooltip>}
            <Typography variant="h5" component="h5" gutterBottom>All Optimized Lineups</Typography>
        </Stack>
        <Grid container spacing={2}>
            {lineups.length > 0 && lineups.map((lineup, index) =>(
                <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
                <Paper elevation={1} sx={{padding:1, margin:1}}>
                <OptimizerTable key={index} lineup={lineup.Info} fpts={lineup.Points} salary={lineup.Salary} isEditable={false} addedPlayers={addedPlayers} index={index}/>
                </Paper>
                </Grid>
            ))}
        </Grid>
        </Paper>
      </>
    );
  }